(function(){
	'use strict';
	angular.module('app.setup')
		.controller('leanSyncConfig', leanSyncConfig);
	leanSyncConfig.$inject = ['$rootScope', '$scope', '$timeout', '$uibModal', 'leanFilterService', 'tableRenderService', 'tableService', 'leanSyncConfigService', 'storeService'];

	function leanSyncConfig($rootScope, $scope, $timeout, $uibModal, leanFilterService, tableRenderService, tableService, leanSyncConfigService, storeService) {

		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		var reportSettingsName = 'LeanSyncMappingConfiguration';
		// Extra query params to send to backend in data requests
		var extraParams = [{}];
		var rendererParams = {};

		$scope.filterService = leanFilterService;
	
		vm.useSiteSwitcher = true;
		vm.showExcel = false;
		vm.isSuperAdmin = $rootScope.authz.isSuperAdmin();
		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.openModal = openModal;
		vm.reportName = 'Table Configuration';

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				// If any data manipulation is needed, do it here
				return response;
			});
		}

		init();

		var columns = [
			{
				'id': 'tableName',
				'display': 'Table Name',
				'enablePinning': false,
				'renderer': tableRenderService.openModal,
				'openModalFunctionName': 'openLeanSyncConfigModal',
				'width': 300
			},
			{
				'id': 'isEnabled',
				'display': 'Enabled',
				'align': 'left',
				'enablePinning': false,
				'width': 100
			},
			{
				'id': 'description',
				'display': 'Description',
				'enablePinning': false,
				'width': 500
			}
		];

		var meta = {
			reportSettingsName: reportSettingsName,
			reportName: vm.reportName,
			reportUrl: '{0}/LeanSyncTables',
			noPaging: true,
			columns: columns,
			pinnedColumns: [],
			defaultSort: 'tableName',
			defaultSortDirection: 'asc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			hideSearch: true,
			setColumnDefaults: true
		};

		function openModal(row) {
			leanSyncConfigService.getTableConfig(row.tableNdx, adminConfig.factory.id)
				.then(function(config) {
					var opts = {
						templateUrl: '/application/f/setup/leansync/leansync-config-table-mappings.html',
						size: 'lg',
						backdrop: 'static',
						controller: 'leanSyncConfigTableMappings as leanSyncConfigTableMappingsCtrl',
						resolve: {
							tableNdx: function() {
								return row.tableNdx;
							},
							tableName: function() {
								return row.tableName;
							},
							config: function() {
								return config;
							}
						}
					};
					
					var instance = $uibModal.open(opts);
					instance.result.then(function(result) {
						$scope.$broadcast('reloadTable');
					});					
				});
		};
	
		function init() {
			$scope.filterService.clearFilters();
			$scope.filterService.useFactoryFilter = false;
			$scope.filterService.useAdminFactory = true;
		}
	}
})();